import { DataBox } from './DataBox'
import { baseModel } from '../model'
import { PageHeader } from './PageHeader'
import { AddModal } from './addModal'
import { EditModal } from './editModal'

export function BaseAdmin() {
    const { addCarVisible, editCarVisible } = baseModel()
    return (
        <>
            <PageHeader />
            <DataBox />
            {addCarVisible && <AddModal />}
            {editCarVisible && <EditModal />}
        </>
    )
}
